export default function PaymentsBillingsSettings() {
    return (
        <div>
            payment billings settings
        </div>
    );
};